<template>
    <Modal size="md" @close="$emit('close')">
        <template #header>
            <div class="text-gray-600">
                {{ editMode ? $t("vue.edit") : $t("vue.setup") }}

                {{ title }} {{ $t("vue.integration") }}
            </div>
        </template>

        <template #body>
            <div class="mb-6 w-full px-6">
                <slot name="inputs" />

                <div class="mt-6 text-sm text-gray-500">
                    {{ $t("vue.for_more_information") }}
                    {{ title }} {{ $t("vue.integration_please") }}
                    <a
                        class="text-custom-blue-500 hover:text-custom-blue-600"
                        :href="documentationUrl"
                        target="_blank"
                        >{{ $t("vue.check_out_our_documentation") }}</a
                    >.
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-between border-t border-gray-200 p-6">
                <AtomicButton color="white" size="md" @click="$emit('close')">
                    {{ $t("vue.cancel") }}
                </AtomicButton>

                <AtomicButton
                    color="yellow"
                    size="md"
                    :disabled="loading || invalidValidation"
                    @click="editMode ? $emit('edit') : $emit('create')"
                >
                    {{ editMode ? $t("vue.edit") : $t("vue.enable") }}
                    {{ $t("vue.integration") }}
                </AtomicButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
defineEmits(["close", "create", "edit"]);

defineProps({
    title: {
        type: String,
        required: true,
    },
    documentationUrl: {
        type: String,
        required: true,
    },
    invalidValidation: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    editMode: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped></style>
